<h2 mat-dialog-title>TERMINOS Y CONDICIONES</h2>
<mat-dialog-content class="mat-typography">
  <p class="mat-body-1 lh-24">
    Inge S.A.G.R. entidad debidamente constituida conforme a las leyes de la
    República de Chile, con Registro Único Tributario 77.201.957-2 y domicilio
    en Avenida Presidente Riesco #5561. Of. 404. Edificio Arrau. Las Condes,
    Santiago, Chile, en adelante referida como "Inge", ha desarrollado una
    plataforma web, accesible a través del sitio web https://inge.cl y/o
    cualquier otra URL que en el futuro pueda sustituirla (en adelante, la
    "Plataforma"). El propósito de esta Plataforma radica en la recopilación,
    administración y gestión de datos personales pertenecientes a diversos
    usuarios (en adelante, el "Usuario" o los "Usuarios", según corresponda). La
    presente Política de Privacidad (en lo sucesivo, la "Política de
    Privacidad") rige el tratamiento de datos efectuado en o por medio de la
    Plataforma. Además, los Términos y Condiciones Generales del Sitio Web de
    Inge, disponibles en el enlace URL https://inge.cl/, se incorporan por
    referencia a los conceptos definidos en el presente documento. Cuando un
    Usuario se registra en Inge y proporciona su información, está colaborando
    no solo para enriquecer su perfil, sino también para que Inge pueda prestar
    un servicio eficiente, ágil, de calidad y personalizado. La preservación de
    la privacidad del Usuario es de la máxima relevancia para Inge. Por
    consiguiente, se informa al Usuario que todos los datos recopilados o a los
    cuales Inge tenga acceso en el marco del uso de la Plataforma y sus
    funcionalidades, o al navegar en la Plataforma, serán tratados conforme a
    las leyes vigentes en la República de Chile y a los términos aquí
    establecidos. Al hacer uso y entrar a la Plataforma, el Usuario otorga su
    consentimiento, tal como lo dispone el artículo 4º de la Ley N° 19.628 sobre
    Protección de la Vida Privada, para la recopilación y tratamiento de sus
    datos de acuerdo con esta Política de Privacidad. Además, el Usuario
    certifica que cuenta con los consentimientos y autorizaciones pertinentes de
    las personas naturales y/o jurídicas, según corresponda, cuyos datos sean
    ingresados en la Plataforma, de manera que Inge pueda llevar a cabo el
    procesamiento de dichos datos, conforme a lo establecido en esta Política de
    Privacidad.
  </p>

  <h3 class="mat-body-2 f-w-600 m-t-16">1. INFORMACIÓN PERSONAL</h3>
  <p class="mat-body-1 lh-24">
    Ciertas secciones o funcionalidades de la Plataforma requieren que el
    Usuario proporcione determinados datos e información, incluyendo información
    de carácter personal (entendida como "Información Personal" y referente a
    información de cualquier índole que permita identificar al Usuario o a la
    persona jurídica que representa, de acuerdo con lo estipulado en la presente
    Política de Privacidad). Esto es necesario para que el Usuario pueda acceder
    y utilizar los servicios brindados por Inge. Para registrarse, Inge solicita
    que los Usuarios creen una cuenta. A tal efecto, el formulario de registro
    exigirá al Usuario los siguientes datos de carácter obligatorio: Número de
    Registro Único Tributario correspondiente a la persona jurídica
    representada. Información de contacto del individuo responsable ante Inge
    (nombre completo, número de teléfono, dirección de correo electrónico, entre
    otros). Identificación del cliente principal. Además, durante el proceso de
    registro, Inge podría requerir los siguientes datos del Usuario y/o de la
    entidad que representa: Áreas de especialización. Descripción detallada de
    las actividades llevadas a cabo. Detalles patrimoniales, deudas pendientes,
    motivo de solicitud de crédito, tipo de empresa. Claves de acceso para
    ingresar a registros financieros, declaraciones de impuestos y otros
    documentos relacionados con el Servicio de Impuestos Internos ("SII"),
    Tesorería General de la República u otros organismos afines. Domicilio
    oficial. Sitio web. Información identificativa en cuentas de redes sociales
    (por ejemplo, Facebook, Twitter, LinkedIn, Skype, etc.). Cualquier otra
    información que Inge considere pertinente para mejorar la calidad de los
    servicios. Inge se reserva el derecho de verificar la información
    proporcionada por el Usuario, incluyendo la Información Personal y cualquier
    otro dato entregado mediante la consulta de entidades públicas, empresas
    especializadas o centrales de riesgo, siempre con el consentimiento expreso
    del Usuario. El Usuario es responsable de asegurar que la Información
    Personal y cualquier otra información facilitada sean veraces, completas y
    precisas. Asimismo, Inge recopila datos relativos al uso que los Usuarios
    hacen de las funciones de la Plataforma y cómo interactúan con ella. Cada
    vez que un Usuario accede a la Plataforma, Inge puede recopilar y almacenar
    cierta información de forma automática en los registros del servidor, como
    la dirección IP, el navegador web utilizado, detalles sobre el dispositivo
    utilizado, entre otros. Al aceptar esta Política de Privacidad, el Usuario
    se compromete a mantener actualizados todos los datos personales que haya
    proporcionado a Inge, garantizando que sean veraces, precisos y estén al
    día, y notificando cualquier modificación que pudiera surgir.
  </p>

  <h3 class="mat-body-2 f-w-600 m-t-16">2. ALMACENAMIENTO LOCAL</h3>
  <p class="mat-body-1 lh-24">
    Inge podría recolectar y conservar datos (incluyendo Información Personal)
    de forma local a través de mecanismos como el almacenamiento web del
    navegador y la memoria caché de datos de aplicaciones. Utiliza diversas
    tecnologías para adquirir y retener datos al acceder a la Plataforma,
    incluyendo el empleo de cookies.
  </p>

  <h3 class="mat-body-2 f-w-600 m-t-16">3. USO DE LOS DATOS RECOPILADOS</h3>
  <p class="mat-body-1 lh-24">
    Los datos recopilados por Inge a través de la Plataforma, incluyendo
    Información Personal, son utilizados para proporcionar los servicios
    ofrecidos por Inge, con objetivos que comprenden, entre otros, los
    siguientes: Gestión y ejecución de los contratos celebrados por el Usuario
    con Inge o a través de ella. Atención y respuesta a consultas, reclamos y
    solicitudes por parte del Usuario. Verificación y validación de la identidad
    del Usuario y de la persona jurídica que representa. Realización de
    evaluaciones crediticias y comerciales. Comunicaciones relacionadas con la
    Plataforma y servicios. Análisis y desarrollo de inteligencia comercial, así
    como la creación de perfiles de usuario. Generación automática de documentos
    necesarios para llevar a cabo transacciones en el sitio web de Inge.
    Ejecución de campañas destinadas a la actualización de Datos Personales y
    acciones de cobranza. Evaluación de riesgos vinculados a operaciones y
    revisión de requisitos asociados a las operaciones del Usuario. Ejecución de
    acciones de marketing tendientes a mejorar los servicios y la experiencia
    del Usuario. Mantenimiento, protección y mejora de la Plataforma, junto con
    el desarrollo de nuevas funcionalidades. Implementación de protocolos de
    seguridad y prevención de usos engañosos, fraudulentos o ilegales de los
    sistemas de Inge. Inge únicamente utilizará los datos de los Usuarios para
    los fines señalados en esta Política de Privacidad y dentro del alcance del
    consentimiento otorgado por los Usuarios. Inge solicitará el consentimiento
    del Usuario antes de emplear y tratar sus datos para cualquier otro
    propósito distinto a los establecidos en la presente Política de Privacidad.
  </p>

  <h3 class="mat-body-2 f-w-600 m-t-16">
    4. TRANSFERENCIA DE DATOS PERSONALES
  </h3>

  <p class="mat-body-1 lh-24">
    No se cederán Datos Personales de los Usuarios a terceros ajenos a Inge,
    excepto en alguno de los siguientes supuestos: A) Consentimiento: Los
    Usuarios han prestado su consentimiento expreso para compartir sus Datos
    Personales. B) Tratamiento Externo: Inge podrá compartir Datos Personales
    y/o información del Usuario con proveedores que lleven a cabo el
    procesamiento de datos en nombre de Inge, cumpliendo con sus directrices y
    adoptando medidas adecuadas para garantizar la confidencialidad y seguridad
    de los datos. C) Requisitos Legales: Los Datos Personales podrán ser
    revelados o transmitidos a terceros cuando exista una obligación legal, se
    cumplan excepciones previstas en la ley o se reciba una orden emitida por
    una autoridad competente. D) Otras Circunstancias: Inge podría compartir
    Datos Personales con terceros en otros contextos, como en la cesión o venta
    de carteras de crédito, operaciones de fusión o adquisición, o acuerdos con
    socios comerciales.
  </p>

  <h3 class="mat-body-2 f-w-600 m-t-16">
    5. SEGURIDAD DE LOS DATOS Y RESPONSABILIDAD DEL USUARIO
  </h3>

  <p class="mat-body-1 lh-24">
    Inge se dedica a garantizar la seguridad y confidencialidad de los Datos
    Personales recolectados a través de la Plataforma mediante la implementación
    de medidas técnicas y organizativas. No obstante, el Usuario comprende que
    ninguna medida de seguridad es infalible y acepta los riesgos asociados con
    la transmisión de información por Internet. Es responsabilidad del Usuario
    proteger sus contraseñas y dispositivos, así como informar a Inge en caso de
    un uso no autorizado de sus credenciales.
  </p>
  <h3 class="mat-body-2 f-w-600 m-t-16">6. APLICABILIDAD</h3>

  <p class="mat-body-1 lh-24">
    Esta Política de Privacidad es aplicable a todas las funcionalidades de la
    Plataforma proporcionadas por Inge, salvo aquellas sujetas a políticas de
    privacidad independientes que no incorporen los términos de esta Política de
    Privacidad.
  </p>
  <h3 class="mat-body-2 f-w-600 m-t-16">7. DERECHOS DEL USUARIO</h3>

  <p class="mat-body-1 lh-24">
    Los Usuarios cuentan con derechos relacionados con sus Datos Personales,
    incluyendo el derecho a acceder, modificar, actualizar o suprimir sus datos.
    Para ejercer estos derechos, los Usuarios pueden ponerse en contacto con
    Inge a través de la dirección de correo electrónico [Tu dirección de correo
    electrónico de contacto] o el número de teléfono [Tu número de teléfono de
    contacto].
  </p>
  <h3 class="mat-body-2 f-w-600 m-t-16">8. CUMPLIMIENTO</h3>

  <p class="mat-body-1 lh-24">
    Inge se compromete a cumplir con la normativa de protección de datos y a
    salvaguardar los Datos Personales de acuerdo con los términos de esta
    Política de Privacidad.
  </p>
  <h3 class="mat-body-2 f-w-600 m-t-16">
    9. MODIFICACIONES DE LA POLÍTICA DE PRIVACIDAD
  </h3>

  <p class="mat-body-1 lh-24">
    Inge se reserva el derecho de modificar esta Política de Privacidad en
    cualquier momento. Las modificaciones se publicarán en la Plataforma y, si
    son sustanciales, se comunicarán a los Usuarios por correo electrónico.
  </p>
  <h3 class="mat-body-2 f-w-600 m-t-16">
    10. ACEPTACIÓN DE LA POLÍTICA DE PRIVACIDAD
  </h3>

  <p class="mat-body-1 lh-24">
    Al utilizar la Plataforma y aceptar los términos y condiciones, el Usuario
    manifiesta su conocimiento y aceptación de esta Política de Privacidad,
    otorgando su consentimiento explícito para el tratamiento de sus Datos
    Personales de conformidad con los términos aquí estipulados y los Términos y
    Condiciones de Inge.
  </p>
</mat-dialog-content>
<mat-dialog-actions class="w-100 d-flex justify-content-center">
  <button mat-stroked-button color="warn" mat-dialog-close>Cerrar</button>
  <button
    mat-stroked-button
    color="success"
    [mat-dialog-close]="data"
    (click)="ok()"
  >
    Aceptar
  </button>
</mat-dialog-actions>
